import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IRecommendedProfessionalApi } from './recommendedProfessionalsTypes';

export interface IGetRecommendedProfessionalsParams {
  officeId: string;
}

async function getRecommendedProfessionals({
  officeId,
}: IGetRecommendedProfessionalsParams): Promise<IRecommendedProfessionalApi[]> {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<{ data: IRecommendedProfessionalApi[] | null }>(
    `/offer-discovery/professionals/recommended`,
    {
      headers: { ...headers, 'x-office': officeId ?? undefined },
    },
  );

  return response?.data?.data ?? [];
}

export const recommendedProfessionalsApi = {
  getRecommendedProfessionals,
};
